import React, { Component } from 'react'

class IconInfo extends Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <title>Info</title>
          <g>
            <path d="M11,17h2v-6h-2v6Zm1-8c.28,0,.52-.1,.71-.29,.19-.19,.29-.43,.29-.71s-.1-.52-.29-.71c-.19-.19-.43-.29-.71-.29s-.52,.1-.71,.29c-.19,.19-.29,.43-.29,.71s.1,.52,.29,.71c.19,.19,.43,.29,.71,.29Zm0,13c-1.38,0-2.68-.26-3.9-.79-1.22-.52-2.28-1.24-3.18-2.14-.9-.9-1.61-1.96-2.14-3.18-.53-1.22-.79-2.52-.79-3.9s.26-2.68,.79-3.9c.52-1.22,1.24-2.28,2.14-3.18,.9-.9,1.96-1.61,3.18-2.14,1.22-.52,2.52-.79,3.9-.79s2.68,.26,3.9,.79c1.22,.53,2.27,1.24,3.18,2.14,.9,.9,1.61,1.96,2.14,3.18,.53,1.22,.79,2.52,.79,3.9s-.26,2.68-.79,3.9c-.52,1.22-1.24,2.27-2.14,3.18-.9,.9-1.96,1.61-3.18,2.14-1.22,.53-2.52,.79-3.9,.79Z"/>
          </g>
      </svg>
    )
  }
}

export default IconInfo;



// WEBPACK FOOTER //
// ./src/components/icons/info/index.js